import React from "react";
import { BASE_API_URL } from "./App.Settings";
import { Environment, apiURL } from "../Services/Base";
import dataJSON from "../../static/api/data.json";
import 'whatwg-fetch'

const Service = {
    currentQuiz: window.CurrentQuiz ? window.CurrentQuiz : {},
    getItems: (callback = null) => {
        if (callback) {
            callback(dataJSON);
            return;
        }
        return dataJSON;
    },
    save: (vote) => {
        let form = window.document.createElement("form");
        form.action = `${apiURL}Handle.ashx`;
        form.method = "post";

        let input = window.document.createElement("input");
        input.type = "hidden";
        input.value = vote;
        input.name = "vote";

        form.appendChild(input);
        console.log(form);


        // const request = await fetch(`${apiURL}Handle.ashx`, Service.asJSONBody({
        //     vote: vote
        // })).then(res => Service.asResJSON(res))
        // .catch(error => console.log(error));

        return "done";
    },
    asStringJSON: body => JSON.stringify(body),
    asResJSON: res => res.json(),
    asJSONBody: body => {
        return {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: Service.asStringJSON(body)
        }
    }
}

window.voteService = Service;

export {
    Service
}


// WEBPACK FOOTER //
// ./src/Components/App/App.Service.jsx